var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg444Bf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.955,
    y: 160.303,
    width: 74.748,
    height: 74.747
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.328,
    y: 264.949,
    width: 74.748,
    height: 74.747
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.516,
    y: 369.595,
    width: 74.747,
    height: 74.748
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.861,
    y: 55.657,
    width: 74.747,
    height: 74.748
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.75,249.918c4.929-76.658,73.935-190.163-58.733-190.163c-111.138,0-118.596,96.192-118.596,190.163 c0,84.969,4.044,186.586,106.526,190.163C486.819,445.067,420.228,335.106,414.75,249.918z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg444Bf);
export default __webpack_public_path__ + "static/media/444bf.9a6254b271d8274001142d601f178ea8.svg";
export { ForwardRef as ReactComponent };